import * as W from '../actions/widgetActions';

export interface Widget {
  id: number;
  title: string;
  charts: Chart[];
  configurations: Configuration;
}

export interface Chart {
  id: number;
  type: string;
  x_axis_label: string | null;
  y_axis_label: string | null;
  data: null;
}
export interface Configuration {
  x: number;
  y: number;
  w: number;
  h: number;
  static: boolean;
}

const initialState = {
  widgets: [] as Widget[],
  widgetDetails: {} as { [key: number]: Widget },
  deviceDetails: [],
};

export const widget = (state = initialState, action) => {
  switch (action.type) {
    case W.fetchWidgetsList.success:
      return {
        ...state,
        widgets: action.payload,
        widgetDetails: {
          ...action.payload.reduce((acc, widget) => {
            acc[widget.id] = widget;
            return acc;
          }, {}),
        },
      };
    case W.fetchWidgetDetails.success:
      return {
        ...state,
        widgetDetails: {
          ...state.widgetDetails,
          [action.payload.id]: action.payload,
        },
      };
    case W.saveWidgetPlacement.success:
      return {
        ...state,
      };
    case W.fetchDeviceReading.success:
      return {
        ...state,
        deviceDetails: action.payload,
      };
    default:
      return state;
  }
};
